(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myPoints", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/gamification/myPointsView.html",
            controller: ["frameworkService", "myAccountResource", "myPointsLeaderboardResource", "messageService", "$translate", "$state", "_", MyPointsCtrl],
            controllerAs: "vm"
        };
        function MyPointsCtrl(frameworkService, myAccountResource, myPointsLeaderboardResource, messageService, $translate, $state, _) {
            var vm = this;
            vm.loading = true;
            vm.opened = {};
            vm.months = [];
            vm.isMobile = jQuery.browser.mobile;
            if (!frameworkService.data.tenantFeatures.gamificationPointSystem) {
                $state.go("main.notFound");
                return;
            }
            vm.leaderBoardEnabled = frameworkService.data.tenantFeatures.gamificationLeaderboardSystem;
            myAccountResource.getMyPointsDashboard(function (data) {
                vm.data = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            if (vm.leaderBoardEnabled) {
                myPointsLeaderboardResource.get(function (data) {
                    vm.leaderboardData = data;
                    if (vm.leaderboardData.currentLeaderboard === null || vm.leaderboardData.leaderboards.length === 0)
                        vm.leaderBoardEnabled = false;
                    else {
                        vm.leaderboardData.selectedLeaderboard = _.find(vm.leaderboardData.leaderboards, function (item) { return item.name === vm.leaderboardData.currentLeaderboard.name; });
                        vm.leaderboardLoaded = true;
                        vm.currentLeaderboardLoaded = true;
                    }
                }, function (error) {
                    messageService.error(error);
                });
            }
            vm.dateMonth = function (date) {
                if (typeof date === "string") {
                    if (date.indexOf("Z") === -1 && date.indexOf("+") === -1) {
                        date += "Z";
                    }
                }
                return $translate.instant("common.month." + new Date(date).getMonth()) + ", " + new Date(date).getFullYear();
            };
            vm.loadLeaderboard = function (leaderboard) {
                vm.leaderboardData.selectedLeaderboard = leaderboard;
                if (leaderboard.isSite) {
                    myPointsLeaderboardResource.getSiteLeaderboard(function (data) {
                        vm.leaderboardData.currentLeaderboard = data;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else if (leaderboard.isOrg) {
                    myPointsLeaderboardResource.getOrganizationLeaderboard(function (data) {
                        vm.leaderboardData.currentLeaderboard = data;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else {
                    myPointsLeaderboardResource.getGroupLeaderboard({ id: leaderboard.id }, function (data) {
                        vm.leaderboardData.currentLeaderboard = data;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            };
            vm.loadHistory = function () {
                if (!vm.historyLoaded) {
                    vm.historyLoading = true;
                    myAccountResource.getMyPointsHistory(function (data) {
                        vm.history = _.groupBy(data.history, function (entry) {
                            var monthYear = vm.dateMonth(entry.createdDate);
                            vm.opened[monthYear] = true;
                            return monthYear;
                        });
                        vm.months = _.map(vm.history, function (data, month) { return month; });
                        vm.loading = false;
                        vm.historyLoading = false;
                        vm.historyLoaded = true;
                        vm.showHistory = true;
                    }, function (error) {
                        messageService.error(error);
                        vm.historyLoading = false;
                    });
                }
                else
                    vm.showHistory = !vm.showHistory;
            };
            vm.dateFilter = function (history) {
                if (vm.selectedDateFilter) {
                    if (history) {
                        return vm.selectedDateFilter === vm.dateMonth(history.createdDate);
                    }
                }
                return true;
            };
        }
    });
}());
